import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import { actions } from "../../modules/dealers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DealerForm from "../../components/DealerForm";
import { compose, lifecycle } from "recompose";

const propTypes = {
  submittingDealer: PropTypes.bool.isRequired,
  failSubmitDealer: PropTypes.string,
  createDealer: PropTypes.func.isRequired
};

const CreateDealer = ({
  submittingDealer,
  failSubmitDealer,
  createDealer,
  history: { push }
}) => {
  const onSubmit = useCallback(
    async values => {
      const result = await createDealer(values);
      if (result.response) {
        push("/dealers");
      }
    },
    [createDealer, push]
  );
  return (
    <div className="content">
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div>
            <h3>Create Dealer</h3>
            <DealerForm
              submittingDealer={submittingDealer}
              failSubmitDealer={failSubmitDealer}
              onSubmit={onSubmit}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = state => ({ ...(state.dealers || {}) });

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(actions, dispatch),
  dispatch
});

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentWillUnmount() {
      this.props.resetState();
    }
  })
);

CreateDealer.propTypes = propTypes;

export default enhance(CreateDealer);
